<header class="sf-header">
  <h1>{{ 'calendar.title' | transloco }}</h1>
</header>

<div class="calendar">
  <div class="sf-section">
    <div>
      <h3 class="sf-section__title">{{ 'calendar.planning.title' | transloco }}</h3>
      <p class="sf-section__subtitle">{{ 'calendar.planning.subtitle' | transloco }}</p>
    </div>
  </div>

  @if (planning && browserTimezone && planning.timezone !== browserTimezone) {
    <div class="sf-section"
      >
      <p>{{'calendar.planning.different-timezones'|transloco: {'user_tz': planning.timezone, 'browser_tz': browserTimezone} }}
      </div>
    }

    <div class="sf-section calendar__planning">
      <table class="hide--md hide--sm">
        <colgroup>
        <col style="width: 14.28%">
        <col style="width: 14.28%;">
        <col style="width: 14.28%;">
        <col style="width: 14.28%;">
        <col style="width: 14.28%;">
        <col style="width: 14.28%;">
        <col style="width: 14.28%;">
      </colgroup>

      <thead>
        <tr>
          @for (day of weekdays; track day) {
            <th>
              {{getWeekdayTranslation(day)}}
            </th>
          }
        </tr>
      </thead>

      <tbody>
        <tr>
          @for (day of weekdays; track day) {
            <td>
              @if (!isLoading && planning) {
                @if (planning.weekdays[day] === null || planning.weekdays[day].length === 0) {
                  <div class="empty-state"
                    >
                    <i class="fa-regular fa-clock empty-state__icon"></i>
                    <p class="empty-state__content">{{'calendar.planning.day.empty-state.content'|transloco}}</p>
                  </div>
                }
                @if (planning.weekdays[day] !== null && planning.weekdays[day].length > 0) {
                  <div
                    class="timeslots"
                    >
                    @for (timeslot of planning.weekdays[day]; track timeslot) {
                      <div
                        class="timeslot"
                        >
                        <button class="button button--secondary button--small button--delete"
                          (click)="openDeleteTimeslotModal(day, timeslot)"
                          >
                          <i class="fa-solid fa-trash-can"></i>
                        </button>
                        <div class="timeslot-times">
                          <p class="timeslot-start">{{timeslot.start_utc | date:'shortTime'}}</p>
                          <p class="timeslot-end">{{timeslot.end_utc | date:'shortTime'}}</p>
                        </div>
                      </div>
                    }
                  </div>
                }
                <button class="button button--full-width button--add"
                  (click)="openAddTimeslotModal(day)"
                  >
                  {{'calendar.planning.day.add-timeslot.cta'|transloco}}
                </button>
              }
              @if (isLoading) {
                <div class="skeleton-loading timeslot"></div>
                <div class="skeleton-loading timeslot"></div>
              }
            </td>
          }
        </tr>
      </tbody>
    </table>

    <table class="hide--lg">
      <tbody>
        @for (day of weekdays; track day) {
          <tr>
            <th>
              {{getWeekdayTranslation(day)}}
            </th>
            <td>
              @if (!isLoading && planning) {
                @if (planning.weekdays[day] === null || planning.weekdays[day].length === 0) {
                  <div class="empty-state"
                    >
                    <i class="fa-regular fa-clock empty-state__icon"></i>
                    <p class="empty-state__content">{{'calendar.planning.day.empty-state.content'|transloco}}</p>
                  </div>
                }
                @if (planning.weekdays[day] !== null && planning.weekdays[day].length > 0) {
                  <div
                    class="timeslots"
                    >
                    @for (timeslot of planning.weekdays[day]; track timeslot) {
                      <div
                        class="timeslot"
                        >
                        <button class="button button--secondary button--small button--delete"
                          (click)="openDeleteTimeslotModal(day, timeslot)"
                          >
                          <i class="fa-solid fa-trash-can"></i>
                        </button>
                        <div class="timeslot-times">
                          <p class="timeslot-start">{{timeslot.start_utc | date:'shortTime'}}</p>
                          <p class="timeslot-end">{{timeslot.end_utc | date:'shortTime'}}</p>
                        </div>
                      </div>
                    }
                  </div>
                }
                <button class="button button--full-width button--add"
                  (click)="openAddTimeslotModal(day)"
                  >
                  {{'calendar.planning.day.add-timeslot.cta'|transloco}}
                </button>
              }
              @if (isLoading) {
                <div class="skeleton-loading timeslot"></div>
                <div class="skeleton-loading timeslot"></div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <app-calendar-add-timeslot-modal
    [open]="isTimeslotModalOpened"
    [day]="dayTimeslotModal"
    (onClose)="closeAddTimeslotModal($event)"
  ></app-calendar-add-timeslot-modal>

  <app-calendar-delete-timeslot-modal
    [open]="isDeleteTimeslotModalOpened"
    [day]="dayTimeslotModal"
    [timeslot]="timeslotToDelete"
    (onClose)="closeDeleteTimeslotModal($event)"
  ></app-calendar-delete-timeslot-modal>
</div>
